<template>
      <p class="title mb-m">
          <slot/>
      </p>
</template>
